import * as yup from "yup";
export const serviceLineItemSchema = yup.object().shape({
  particulars: yup.string(),
  itemUnit: yup.string(),
  totalWithoutGst: yup.string(),
  totalWithGst: yup.string(),
  itemQuantity: yup.string(),
  discount: yup.string(),
  itemPrice: yup.string(),
  gstRate: yup.string(),
  deliveryDate: yup.string(),
  notes: yup.string(),
  id: yup.string(),
  hsn: yup.string(),
  sku: yup.string(),
  itemFrom: yup.string(),
});

export const ServiceOrderSchema = yup.object().shape({
  project: yup.string(),
  vendor: yup.string().required("Required"),
  poType: yup.string().required("Required"),
  /////////// new Added
  vendorInvoiceNumber: yup.string(),
  paymentPriority: yup.string(),
  taxInvoice: yup.mixed(),
  performaInvoice: yup.mixed(),
  approveStatus: yup.boolean(),
  paymentAmount: yup.string(),
  paymentType: yup.string(),
  notes: yup.string(),
  //////////////
  pdfStatus: yup.boolean(),
  countryOfSupply: yup.string(),
  placeOfSupply: yup.string(),
  generatedBy: yup.string(),
  vendorServiceOrderDate: yup.date(),
  vendorServiceOrderFor: yup.string(),
  lineItems: yup.array().of(serviceLineItemSchema),
});
